import "bootstrap-icons/font/bootstrap-icons.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box, Spinner, Flex } from "@chakra-ui/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ROUTES, COURSE_ROUTES } from "./constants/routes";

const Home = lazy(() => import("./pages/Home"));
const Course1 = lazy(() => import("./pages/courses/Course1"));
const Course2 = lazy(() => import("./pages/courses/Course2"));
const Course3 = lazy(() => import("./pages/courses/Course3"));
const Course4 = lazy(() => import("./pages/courses/Course4"));
const Course5 = lazy(() => import("./pages/courses/Course5"));
const Result = lazy(() => import("./pages/Result"));
const Gallery = lazy(() => import("./pages/Gallery"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const ApplyOnline = lazy(() => import("./pages/ApplyOnline"));
const Enquiry = lazy(() => import("./pages/Enquiry"));
const NotFound = lazy(() => import("./pages/WrongPage"));
const RefundRules = lazy(() => import("./pages/RefundRules"));
const RulesAndRegulations = lazy(() => import("./pages/Rules_and_regulations"));

const ROUTE_CONFIG = [
  { path: ROUTES.HOME, element: <Home /> },
  { path: COURSE_ROUTES.XI_FRESHER, element: <Course1 /> },
  { path: COURSE_ROUTES.XII_TARGET, element: <Course2 /> },
  { path: COURSE_ROUTES.VIII_FOUNDATION, element: <Course3 /> },
  { path: COURSE_ROUTES.IX_FOUNDATION, element: <Course4 /> },
  { path: COURSE_ROUTES.X_FOUNDATION, element: <Course5 /> },
  { path: ROUTES.RESULTS, element: <Result /> },
  { path: ROUTES.GALLERY, element: <Gallery /> },
  { path: ROUTES.ABOUT_US, element: <AboutUs /> },
  { path: ROUTES.CONTACT_US, element: <ContactUs /> },
  { path: ROUTES.APPLY_ONLINE, element: <ApplyOnline /> },
  { path: ROUTES.ENQUIRY, element: <Enquiry /> },
  { path: ROUTES.RULES_AND_REGULATIONS, element: <RulesAndRegulations /> },
  { path: ROUTES.REFUND_AND_CANCELLATION, element: <RefundRules /> },
  { path: ROUTES.NOT_FOUND, element: <NotFound /> },
];

function PageLoader() {
  return (
    <Flex justify="center" align="center" py={12}>
      <Spinner size="xl" color="brand.red" thickness="3px" />
    </Flex>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Box minH="100vh" display="flex" flexDirection="column">
        <Header />
        <Box as="main" flex="1" w="100%" minW={0}>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {ROUTE_CONFIG.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
            </Routes>
          </Suspense>
        </Box>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
